{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "docusaurus:pages:3.10",
  "title": "Docusaurus pages front matter v3.10",
  "description": "Front matter accepted by @docusaurus/plugin-content-pages as of Docusaurus 3.10. Docusaurus marks no field as required, so this is a format check, not a presence check. Unknown keys are tolerated, matching Docusaurus. The field set is the smallest of the three: standalone pages carry no sidebar, pagination, or tag metadata. See https://docusaurus.io/docs/api/plugins/@docusaurus/plugin-content-pages#markdown-front-matter",
  "type": "object",
  "additionalProperties": true,
  "properties": {
    "title": {
      "type": "string",
      "description": "Page title. Defaults to the Markdown title. May be empty."
    },
    "description": {
      "type": "string",
      "description": "Meta description for search engines. Defaults to the first line of Markdown content. May be empty."
    },
    "keywords": {
      "type": "array",
      "items": { "type": "string" },
      "description": "Keywords meta tag for search engines."
    },
    "image": {
      "type": "string",
      "format": "uri-reference",
      "description": "Cover image used in social link previews. A site-root path such as `/img/card.png` is legal."
    },
    "slug": {
      "type": "string",
      "description": "Custom URL for this page. Defaults to the file path; `/` makes it the site root."
    },
    "wrapperClassName": {
      "type": "string",
      "description": "Class name added to the page wrapper, for targeting this page in CSS."
    },
    "hide_table_of_contents": {
      "type": "boolean",
      "description": "Hide the right-hand table of contents."
    },
    "draft": {
      "type": "boolean",
      "description": "A draft page is available in development only. Cannot be combined with `unlisted`."
    },
    "unlisted": {
      "type": "boolean",
      "description": "An unlisted page is published but hidden from search and sitemaps. Cannot be combined with `draft`."
    }
  },
  "if": {
    "required": ["draft"],
    "properties": { "draft": { "const": true } }
  },
  "then": {
    "properties": { "unlisted": { "const": false } }
  }
}
